import { Box, freddyTheme, List, ListItem } from '@coolblue-development/freddy';
import { MinusCircled, PlusCircled } from '@coolblue-development/icons';
import { IconWithText } from '@coolblue-development/next-patterns/client';
import { ReactElement } from 'react';

type IconSize = 'small' | 'medium' | 'large';
export default function ProsAndCons({
  pros,
  cons,
  iconSize = 'small'
}: {
  pros: string[];
  cons?: string[];
  iconSize?: IconSize;
}): ReactElement {
  return (
    <Box>
      <List gap='none' marker='none'>
        {pros.map(pro => (
          <ListItem key={pro}>
            <IconWithText
              color={freddyTheme.color.icon.sentimentPositive}
              description={pro}
              icon={
                <Box
                  mr={freddyTheme.spacing[50]}
                  sx={theme => ({
                    svg: { marginBottom: theme.spacing[100] }
                  })}
                >
                  <PlusCircled size={iconSize} />
                </Box>
              }
              alignItems='flex-start'
            />
          </ListItem>
        ))}
        {cons?.map(cons => (
          <ListItem key={cons}>
            <IconWithText
              color={freddyTheme.color.icon.sentimentNegative}
              description={cons}
              icon={
                <Box
                  mr={freddyTheme.spacing[50]}
                  sx={theme => ({
                    svg: { marginBottom: theme.spacing[100] }
                  })}
                >
                  <MinusCircled size={iconSize} />
                </Box>
              }
              alignItems='flex-start'
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
}
